import React, { ReactNode, useId } from 'react'
import { PktInputWrapper, PktRadioButton } from '@oslokommune/punkt-react'
import { Control, FieldValues, Path, useController } from 'react-hook-form'

type RadioButtonsProps<T extends FieldValues> = React.HTMLAttributes<HTMLDivElement> & {
    control: Control<T>
    name: Path<T>
    label: string
    helptext?: string
    hasTile?: boolean
    options: Array<{ value: string; label: string, helptext?: string }>
    errorMessage?: string | ReactNode | Array<ReactNode>
    rules?: object
    shouldTranslateValue?: 'yes' | 'no'
    shouldTranslateLabel?: 'yes' | 'no'
}

export default function RadioButtons<T extends FieldValues>({
    name,
    control,
    label,
    helptext,
    options,
    errorMessage,
    hasTile = false,
    rules = { required: 'Dette spørsmålet må besvares' },
    shouldTranslateValue,
    shouldTranslateLabel,
    ...restProps
}: RadioButtonsProps<T>) {
    const { field, fieldState } = useController({ name, control, rules })

    const id = useId()
    const wrapperClasses = `${restProps.className} ${shouldTranslateLabel === 'no' ? 'notranslate' : ''}`
    const radioButtonClasses = `mt-size-16 ${shouldTranslateLabel === 'no' ? 'notranslate' : ''}`

    return (
        <PktInputWrapper
            {...restProps}
            className={wrapperClasses}
            hasError={!!fieldState.error}
            errorMessage={fieldState.error?.message || errorMessage}
            forId={id}
            label={label}
            helptext={helptext}
            hasFieldset
        >
            {options.map(({ value, label, helptext }, i) => (
                <PktRadioButton
                    className={radioButtonClasses}
                    key={`${id}-${i}`}
                    id={`${id}-${i}`}
                    checkHelptext={helptext}
                    ref={i === 0 ? field.ref : undefined} //bare sett ref på første, så det er den som får focus
                    name={field.name}
                    onChange={field.onChange}
                    checked={field.value === value}
                    hasTile={hasTile}
                    disabled={field.disabled}
                    label={label}
                    value={value}
                />
            ))}
        </PktInputWrapper>
    )
}
